/// <amd-module name="Feed/Legacy/Actions/FeedSettings/ChangeSelectedViewsHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { FeedView } from "Feed/Common/Contracts/Feed";

export class ChangeSelectedViewsHandler {
    public static handle(state: IFeedSettingsState, views: FeedView[]): void {
        state.selectedViews = views;
    }
}
